export type JumperKind = 'rays' | 'multiline';

export abstract class Jumper {
    abstract kind: JumperKind;
    abstract init(): Promise<void>;
    abstract dispose(): void;
    abstract getMin(): number;
    abstract getMax(): number;
}
